module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/guitar-v2-daf0baff67617044999157a5c08f7468.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/guitar-v2.svg
// module id = /qlG
// module chunks = 1 3 10 12 18